"use client";

import classNames from "@/helpers/classNames";
import Icon from "@/components/Icon";
import Text from "@/components/Text";
import styles from "./styles.module.scss";

export interface ProductDonationProps {
  selected?: boolean;
  onClick?: () => void;
  title?: string;
  subtitle?: string;
  className?: string;
}

const ProductDonation = ({
  selected = false,
  onClick,
  title = "Just want to make a donation",
  subtitle = "No card needed",
  className,
}: ProductDonationProps) => (
  <button
    type="button"
    className={classNames(styles.card, { [styles.cardSelected]: selected }, className)}
    onClick={onClick}
    aria-pressed={selected}
  >
    <div className={styles.left}>
      <div className={styles.icon}>
        <Icon title="heartFill" size="sm" />
      </div>
      <Text as="span" text={title} size="md" weight="semibold" />
    </div>
    <Text as="span" text={subtitle} size="xs" color="themeFgMuted" />
  </button>
);

export default ProductDonation;
